import { AfterViewInit, Component, ElementRef, HostListener, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, EMPTY, pluck, Subscription, switchMap } from 'rxjs';
import { Cart } from 'src/app/interfaces/common/cart';
import { Product } from 'src/app/interfaces/common/product';
import { ShopInformation } from 'src/app/interfaces/common/shop-information.interface';
import { User } from 'src/app/interfaces/common/user.interface';
import { FilterData } from 'src/app/interfaces/core/filter-data';
import { ManageAddressComponent } from 'src/app/pages/account/manage-address/manage-address.component';
import { AccountService } from 'src/app/services/common/account.service';
import { CartService } from 'src/app/services/common/cart.service';
import { ProductListService } from 'src/app/services/common/product-list.service';
import { ProductService } from 'src/app/services/common/product.service';
import { UserDataService } from 'src/app/services/common/user-data.service';
import { ReloadService } from 'src/app/services/core/reload.service';
import { PricePipe } from 'src/app/shared/pipes/price.pipe';
import { Address } from "../../../interfaces/common/address.interface";
import { UserService } from '../../../services/common/user.service';
import { WishListService } from '../../../services/common/wish-list.service';
import { UploadPrescriptionPopupComponent } from '../upload-prescription-popup/upload-prescription-popup.component';
import { CartSlideComponent } from './cart-slide/cart-slide.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { UiService } from "../../../services/core/ui.service";
import { RequestMedicineComponent } from "../../dialog-view/request-medicine/request-medicine.component";
import { StorageService } from '../../../services/core/storage.service';
import { DATABASE_KEY } from '../../../core/utils/global-variable';
import { OrderService } from '../../../services/common/order.service';
import { Order } from '../../../interfaces/common/order';
import { DataLayerService } from '../../../services/core/data-layer.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [PricePipe],
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  // Store Data
  @ViewChild('side_nav') side_nav: SideNavComponent;
  @ViewChild('cart_slide') cart_slide: CartSlideComponent;

  headerFixed = false;
  productCategoryBar: boolean = false;
  cartAnimate = false;
  resSearchShow = false;
  user: User = null;
  isBottomNav = true;
  addresses: Address[] = [];
  selectedAddress: Address;
  shopInfo: ShopInformation | any;
  shopInfoByFb: ShopInformation | any;
  isUserAuth: boolean = false;

  // Search Data
  searchProducts: Product[] = [];
  cartSlide = false;

  // Search Control Data
  searchQueryProduct: string;
  overlay = false;
  isOpen = false;
  isOpen1 = false;
  isFocused = false;
  isLoading = false;
  searchQuery: string;

  toggleStyle: boolean = false;
  selectArray: any[] = [];
  allOrders: Order[];
  pendingOrders: Order[];

  toggle() {
    this.toggleStyle = !this.toggleStyle;
  }

  // when i click the contact button, show/hide the facebook/whats app icon
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    // Check if the clicked target is not part of the header
    if (!(event.target as HTMLElement).closest('.icon-bar')) {
      this.toggleStyle = false;
    }
  }

  // Side Nav Show And Hide
  showHideSideNav: boolean = false;
  @ViewChild('searchForm') searchForm: NgForm;
  @ViewChild('searchInput') searchInput: ElementRef;

  // Placeholder Animation
  timeOutOngoing: any;
  char = 0;
  // txt = 'Search by brand or generic...';
  txt = 'Search by medicine...';

  // Cart Data
  carts: Cart[] = [];

  // Wishlist Data
  wishLists: Cart[] = [];

  // Subscriptions
  private subGetData1: Subscription;
  private subGetData2: Subscription;
  private subGetData3: Subscription;
  private subGetData4: Subscription;
  private subReloadData1: Subscription;
  private subReloadData2: Subscription;
  private subReloadData3: Subscription;
  private subReloadData4: Subscription;
  private subDeleteData1: Subscription;
  private subFormData: Subscription;
  private subReloadData: Subscription;

  // Inject
  private readonly _productList = inject(ProductListService);
  public readonly userService = inject(UserService);
  public readonly cartService = inject(CartService);
  public readonly wishListService = inject(WishListService);
  public readonly reloadService = inject(ReloadService);
  public readonly productService = inject(ProductService);
  public readonly pricePipe = inject(PricePipe);
  public readonly router = inject(Router);
  public readonly dialog = inject(MatDialog);
  public readonly userDataService = inject(UserDataService);
  public readonly _accountService = inject(AccountService);
  public readonly activatedRoute = inject(ActivatedRoute);
  public readonly uiService = inject(UiService);
  public readonly storageService = inject(StorageService);
  private readonly orderService = inject(OrderService);
  private readonly dataLayerService = inject(DataLayerService);


  ngOnInit(): void {

    this.headerProductCategoryBarShow();
    this.checkCategoryBarVisibility();

    this.selectArray = this.storageService.getDataFromLocalStorage(DATABASE_KEY.searchHoldData);
    // CART RELOAD DATA AND GET DATA
    this.subReloadData2 = this.reloadService.refreshCart$.subscribe((refresh) => {
      this.getCartsItems(refresh);
    });
    this.getCartsItems();

    // WISHLIST RELOAD DATA AND GET DATA
    this.subReloadData3 = this.reloadService.refreshWishList$.subscribe((refresh) => {
      this.getWishListItemFromLocalStorage(refresh);
    });
    this.getWishListItemFromLocalStorage();

    this.subGetData4 = this.reloadService.getHeaderData.subscribe(res => {
      if (res) {
        this.shopInfo = res;
        this.shopInfoByFb = this.shopInfo.socialLinks.find(f => f.type === 0)
      }
    })

    this.subReloadData1 = this.reloadService.refreshData$.subscribe(() => {
      setTimeout(() => {
        if (this.userService.getUserStatus()) {
          this.getLoggedInUserInfo();
          // Refresh cart when user logs in - delay to ensure user status is set
          setTimeout(() => {
            this.getCartsItems(true);
          }, 300);
        } else {
          this.user = null;
          // Refresh cart when user logs out
          this.getCartsItems(true);
        }
      }, 100)
    });

    if (this.userService.getUserStatus()) {
      this.getLoggedInUserInfo();
      // Load cart if user is already logged in
      setTimeout(() => {
        this.getCartsItems();
      }, 200);
    }
    this.subReloadData4 = this.reloadService.refreshData$.subscribe((res) => {
      if (this.userService.getUserStatus()) {
        this.getUserAddress();
      }
    })

    if (this.userService.getUserStatus()) {
      this.getUserAddress();
    }
    this.bottomNavHideWithRouter();

    this.reloadService.refreshCartSlide$.subscribe((res) => {
      if (res) {
        this.onCartSideToggling();

      }
    })

    this.subGetData2 = this.activatedRoute.queryParamMap.subscribe((res) => {
      if (res.get('dialogOpen') !== null) {
        if (res.get('dialogOpen') === 'true') {
          this.isOpen1 = true;
        } else {
          this.dialog.closeAll();
        }
      } else {
        this.dialog.closeAll();
      }
    })
    this.subGetData2 = this.dialog.afterAllClosed.subscribe(() => {
      this.router.navigate([], { queryParams: { dialogOpen: null }, queryParamsHandling: 'merge' });
    });

    this.subReloadData = this.reloadService.refreshData$.subscribe(() => {
      if (this.userService.getUserStatus()) {
        this.getOrdersByUser();
      }
    })
    if (this.userService.getUserStatus()) {
      this.getOrdersByUser();
    }

    // this.getShopInfo();
  }

  /**
   * headerProductCategoryBarShow()
   */
  private headerProductCategoryBarShow() {
    this._productList.headerProductCategoryBarShow.subscribe(
      res => {
        this.productCategoryBar = res;
      }
    );
  }

  /**
   * checkCategoryBarVisibility()
   * Show Categories button on home and product-list pages
   */
  private checkCategoryBarVisibility() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        const url = this.router.url;
        if (url === '/' || url.indexOf('/product-list') > -1) {
          this._productList.headerProductCategoryBarShow.next(true);
        } else {
          this._productList.headerProductCategoryBarShow.next(false);
        }
      }
    });

    // Check initial route
    const url = this.router.url;
    if (url === '/' || url.indexOf('/product-list') > -1) {
      this._productList.headerProductCategoryBarShow.next(true);
    } else {
      this._productList.headerProductCategoryBarShow.next(false);
    }
  }


  onKeyPress($event) {
    console.log($event.target.value)
  }

  ngAfterViewInit(): void {
    const formValue = this.searchForm?.valueChanges;
    this.subFormData = formValue?.pipe(
      pluck('searchTerm'),
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(data => {
        this.searchQuery = data.trim();
        if (this.searchQuery === '' || this.searchQuery === null) {
          this.overlay = false;
          this.searchProducts = [];
          this.searchQuery = null;
          return EMPTY;
        }
        this.isLoading = true;
        const pagination: any = {
          pageSize: 12,
          currentPage: 0
        };
        const mSelect = {
          name: 1,
          slug: 1,
          images: 1,
          category: 1,
          generic: 1,
          subCategory: 1,
          brand: 1,
          prices: 1,
          variationsOptions: 1,
          status: 1,
          milligram: 1,
          type: 1,
          isPrescription: 1,
        }

        const filterData: FilterData = {
          pagination: pagination,
          filter: { status: 'publish' },
          select: mSelect,
          sort: { name: 1 }
        }
        return this.productService.getAllProducts(filterData, this.searchQuery);
      })
    )
      .subscribe({
        next: res => {
          this.isLoading = false;
          this.searchProducts = res.data.sort((a, b) => a.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) - b.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()));
          // this.searchProducts = res.data.filter(product =>
          //   product.name.toLowerCase().startsWith(this.searchQuery.toLowerCase())
          // );
          if (this.searchProducts?.length > 0) {
            this.isOpen = true;
            this.overlay = true;
          }
        },
        error: err => {
          this.isLoading = false;
          console.log(err);
        }
      });

    this.searchAnim();
  }

  /**
   * HTTP REQUEST HANDLE
   * getLoggedInUserInfo()
   * getUserAddress()
   */


  getOrdersByUser(data?: { orderStatus: number }) {
    const mSelect = {
      orderId: 1,
      paymentType: 1,
      grandTotal: 1,
      orderStatus: 1,
      orderedItems: 1,
      deliveryCharge: 1,
      paymentStatus: 1,
      createdAt: 1,
      user: 1,
      shippingAddress: 1,
      checkoutDate: 1,
      deliveryCode: 1,
      deliveryMan: 1,
      deliveryAssignStatus: 1,

    }
    const filterData: FilterData = {
      select: mSelect,
      pagination: null,
      sort: { createdAt: -1 },
      filter: data !== null ? data : null
    }

    this.subGetData3 = this.orderService.getOrdersByUser(filterData).subscribe({
      next: res => {
        if (res.success) {
          this.allOrders = res.data;
          this.pendingOrders = this.allOrders.filter(f => f.orderStatus === 1)
        }
      },
      error: err => {
        console.log(err);
      }
    }
    )
  }


  private getLoggedInUserInfo() {
    this.subGetData2 = this.userDataService.getLoggedInUserData()
      .subscribe({
        next: res => {
          if (res) {
            this.user = res.data;
          }
        },
        error: err => {
          console.log(err);
        }
      });
  }

  private getUserAddress() {
    this.subGetData3 = this.userDataService.getUserAddress().subscribe({
      next: res => {
        if (res.success) {
          this.addresses = res.data;
          this.selectedAddress = this.addresses.find((res) => res.setDefaultAddress === true);
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }

  /**
   * CART FUNCTIONS
   * getCartsItems()
   * getCarsItemFromLocal()
   */
  private getCartsItems(refresh?: boolean) {
    if (this.userService.getUserStatus()) {
      // Unsubscribe previous subscription to avoid memory leaks
      if (this.subGetData1) {
        this.subGetData1.unsubscribe();
      }
      this.subGetData1 = this.cartService.getCartByUser()
        .subscribe({
          next: res => {
            if (res && res.data && Array.isArray(res.data)) {
              this.carts = res.data.filter(cart => cart && cart.product); // Filter out invalid carts
              this.cartService.updateCartList(this.carts);
              // Only delete NaN carts if we have valid carts
              if (this.carts.length > 0) {
                this.onDeletedNaNCart();
              }
            } else {
              this.carts = [];
              this.cartService.updateCartList(this.carts);
            }
            if (refresh) {
              this.cartAnimate = true;
              setTimeout(() => {
                if (this.cartAnimate == true) {
                  this.cartAnimate = false;
                }
              }, 1000)
            }
          },
          error: err => {
            console.error('Error loading cart:', err);
            // Set empty cart on error
            this.carts = [];
            this.cartService.updateCartList(this.carts);
            // Don't show error to user, just log it
          }
        });
    } else {
      this.getCarsItemFromLocal(refresh);
    }
  }

  private getCarsItemFromLocal(refresh?: boolean) {
    const items = this.cartService.getCartItemFromLocalStorage();
    if (items && items.length > 0) {
      const ids: string[] = items.map(m => m.product as string);
      const select = 'name salePrice sku discountType discountAmount images quantity category subCategory brand tags prices';
      this.productService.getProductByIds(ids, select)
        .subscribe(res => {
          const products = res.data;

          if (products && products.length > 0) {
            const carts = items.map(t1 => ({ ...t1, ...{ product: products.find(t2 => t2._id === t1.product) } }));
            carts.forEach(data => {
              const priceData = data?.product?.prices.find(f => f._id === data.priceId);
              data.product = {
                ...data.product,
                ...{
                  salePrice: priceData?.salePrice,
                  discountAmount: priceData?.discountAmount,
                  discountType: priceData?.discountType,
                  quantity: priceData?.quantity,
                }
              }
            })

            this.carts = carts;
            this.cartService.updateCartList(this.carts);
            if (refresh) {
              this.cartAnimate = true;
              setTimeout(() => {
                if (this.cartAnimate == true) {
                  this.cartAnimate = false;
                }
              }, 1000)
            }
          }
        });
    } else {
      this.carts = [];
      this.cartService.updateCartList(this.carts);
    }
  }

  private onDeletedNaNCart() {
    // Only delete carts if product is missing or invalid
    this.carts.forEach((v, i) => {
      const product = v.product as Product;
      // Check if product exists and has valid salePrice
      if (!product || (product && !product.salePrice && product.salePrice !== 0)) {
        if (v._id) {
          this.onDeleteCartItem(v._id, product?._id, v.priceId);
        }
      }
    })
  }

  onDeleteCartItem(cartId?: string, productId?: string, priceId?: string) {
    if (this.userService.getUserStatus()) {
      this.deleteCartById(cartId)
    } else {
      this.cartService.deleteCartItemFromLocalStorage(productId, priceId);
      this.reloadService.needRefreshCart$();
    }
  }

  deleteCartById(cartId: string) {
    this.subDeleteData1 = this.cartService.deleteCartById(cartId)
      .subscribe({
        next: (() => {
          this.reloadService.needRefreshCart$();
        }),
        error: (error => {
          console.log(error);
        })
      });
  }


  /**
   * WISHLIST FUNCTIONS
   * getWishListItemFromLocalStorage()
   */
  private getWishListItemFromLocalStorage(refresh?: boolean) {
    const items = this.wishListService.getWishListItemFromLocalStorage();
    if (items && items.length > 0) {
      const ids: string[] = items.map((m) => m.product as string);
    } else {
      this.wishLists = [];
      this.wishListService.updateWishListList(this.wishLists);
    }
  }

  /**
   * CART SUBTOTAL CALCULATION
   * cartSubTotal()
   */
  get cartSubTotal(): number {
    const productOnCartTotalDiscountAmount = this.carts.map((t) => {
      return this.pricePipe.transform(
        t.product as Product,
        'discountAmount',
        t.selectedQty
      ) as number;
    })
      .reduce((acc, value) => acc + value, 0);


    const productOnCartTotalSalesPrice = this.carts.map((t) => {
      return ((t.product as Product)?.salePrice * (t.selectedQty))

    }).reduce((acc, value) => acc + value, 0)

    return (productOnCartTotalSalesPrice - productOnCartTotalDiscountAmount);
  }


  /**
   * HANDLE SEARCH Area
   * onClickHeader()
   * onClickSearchArea()
   * handleFocus()
   * setPanelState()
   * handleOpen()
   * handleOutsideClick()
   * handleCloseOnly()
   * handleCloseAndClear()
   * onSelectItem()
   */
  onClickHeader(): void {
    this.searchInput.nativeElement.value = '';
    this.handleCloseOnly();
    this.searchProducts = [];
  }

  onClickSearchArea(event: MouseEvent): void {
    event.stopPropagation();
  }

  handleFocus(event: FocusEvent): void {
    this.searchInput.nativeElement.focus();
    if (this.isFocused) {
      return;
    }
    if (this.searchProducts.length > 0) {
      this.setPanelState(event);
    }
    this.isFocused = true;
    let target = this.searchInput.nativeElement as HTMLInputElement;
    target.placeholder = '';
    clearInterval(this.timeOutOngoing);
  }

  handleBlur() {
    this.searchAnim();
    this.char = 0;
  }

  private setPanelState(event: FocusEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.isOpen = false;
    this.handleOpen();
  }

  handleOpen(): void {
    if (this.isOpen || (this.isOpen && !this.isLoading)) {
      return;
    }
    if (this.searchProducts.length > 0) {
      this.isOpen = true;
      this.overlay = true;
    }
  }

  handleOutsideClick(): void {
    this.searchInput.nativeElement.value = '';
    if (!this.isOpen) {
      return;
    }
    this.isOpen = false;
    this.overlay = false;
    this.isFocused = false;
    this.searchProducts = [];
  }

  handleCloseOnly(): void {
    if (!this.isOpen) {
      this.isFocused = false;
      return;
    }
    this.isOpen = false;
    this.overlay = false;
    this.isFocused = false;
  }

  handleCloseAndClear(): void {
    if (!this.isOpen) {
      this.isFocused = false;
      return;
    }
    this.isOpen = false;
    this.overlay = false;
    this.searchProducts = [];
    this.isFocused = false;
  }

  onSelectItem(data: Product): void {
    this.searchInput.nativeElement.value = '';
    this.handleCloseAndClear();
    const searchData = this.storageService.getDataFromLocalStorage(DATABASE_KEY.searchHoldData)
    this.selectArray = searchData ? searchData : [];

    let findIndex = this.selectArray.findIndex((m) => m.name === data?.name);
    if (findIndex === -1) {
      this.selectArray.splice(0, 0, { name: data?.name });
      // this.selectArray.push({ name: data?.name });

      this.storageService.storeDataToLocalStorage(this.selectArray, DATABASE_KEY.searchHoldData);
    }

    // google tag
    this.searchTag(data?.name)
    this.router.navigate(['/products/details', data?.slug]);


  }


  onSearchNavigate() {
    let inputVal = (this.searchInput.nativeElement as HTMLInputElement).value;
    if (inputVal) {
      this.router.navigate(['/', 'product-list'], {
        queryParams: { searchQuery: inputVal },
        queryParamsHandling: ''
      });
      this.searchInput.nativeElement.value = "";
      this.isOpen = false;
      this.reloadService.needRefreshSearch$(true);
    }
  }

  onNavigate() {
    if (this.router.url === '/') {
      this.onReload();
    } else {
      this.router.navigate(['/']);
    }
  }

  onReload() {
    window.location.reload();
  }

  onDeleteStoredSearch(event: any, name: string) {
    event.stopPropagation();
    const fIndex = this.selectArray.findIndex(f => f.name === name);
    this.selectArray.splice(fIndex, 1);
    this.storageService.storeDataToLocalStorage(this.selectArray, DATABASE_KEY.searchHoldData);

  }

  /**
   * SEARCH PLACEHOLDER ANIMATION
   */

  private searchAnim() {
    const target = this.searchInput.nativeElement as HTMLInputElement;
    target.placeholder = '|';
    this.typeIt(target);
  }

  private typeIt(target: HTMLInputElement) {
    const humanize = Math.round(Math.random() * (300 - 30)) + 30;
    this.timeOutOngoing = setTimeout(() => {
      this.char++;
      const type = this.txt.substring(0, this.char);
      target.placeholder = type + '|';
      this.typeIt(target);
      if (this.char === this.txt.length) {
        target.placeholder = '|';
        this.char = 0;
      }
    }, humanize);
  }


  /**
   * SIDE-NAV AND CART-SLIDE SHOW AND HIDE
   * onSideNavToggling();
   * onCartSideToggling();
   * onProductCategoryShow()
   * resSearchBoxToggle()
   */
  onSideNavToggling() {
    this.side_nav.onShowSlide();
  }

  onCartSideToggling() {
    this.cart_slide.onShowCart();
    this.viewCartGTag();


  }

  onProductCategoryShow() {
    this._productList.onProductCategory();
  }

  onProductsClick() {
    this._productList.headerProductCategoryBarShow.next(true);
  }

  resSearchBoxToggle() {
    this.resSearchShow = !this.resSearchShow;
  }

  private bottomNavHideWithRouter() {
    this.router.events.subscribe((e) => {
      if (!(e instanceof NavigationEnd)) {
        if (this.router.url.indexOf('checkout') > -1) {
          this.isBottomNav = false;
        } else {
          this.isBottomNav = true;
        }
      }
    })
    if (this.router.url.indexOf('checkout') > -1) {
      this.isBottomNav = false;
    } else {
      this.isBottomNav = true;
    }
  }


  // Google tag
  private viewCartGTag() {

    const eventObj = {
      event: "view_cart",
      ecommerce: {
        currency: "BDT",
        value: this.cartSubTotal,
        items: this.carts.map((m, index) => {
          return {
            index: index,
            item_id: (m?.product as Product)?._id,
            product_id: (m?.product as Product)?._id,
            variant_id: m?.priceId,
            item_name: (m?.product as Product)?.name,
            affiliation: "Quick Pharma",
            discount: this.pricePipe.transform((m?.product as Product), 'discountAmount') ?? 0,
            item_brand: (m?.product as Product)?.brand ?? (m?.product as Product)?.brand?.name,
            price: this.pricePipe.transform((m?.product as Product), 'salePrice'),
            quantity: m?.selectedQty
          };
        }),

      }
    }
    this.dataLayerService.eventTrack(eventObj);
  }

  // google tag search
  private searchTag(data: any) {
    const eventObj = {
      event: "search",
      ecommerce: {
        search_term: data,
      }
    }

    this.dataLayerService.eventTrack(eventObj);
  }

  /**
   * MATERIAL POPUP FUNCTION FOR UPLOAD PRESCRIPTION
   * onShowUploadPrescription()
   */
  onShowUploadPrescription() {
    if (this.userService.getUserStatus()) {
      this.router.navigate([], { queryParams: { dialogOpen: true }, queryParamsHandling: 'merge' });
      this.dialog.open(UploadPrescriptionPopupComponent, {
        maxWidth: "751px",
        width: "100%",
        height: "auto",
      });
    } else {
      this.uiService.warn("Please Login First")
      this.router.navigate(['/login'])
    }

  }

  cartSlideShow() {
    this.cartSlide = true;
    this.side_nav.onHideCategory();
  }

  onshowHideSideNav() {
    this.showHideSideNav = !this.showHideSideNav;
  }

  showCategory() {
    this.side_nav.onShowSlide();
  }

  /**
   * HEADER FIXED FUNCTION
   */
  @HostListener('window:scroll')
  scrollBody() {
    if (window.scrollY > 0) {
      this.headerFixed = true;
    } else {
      this.headerFixed = false;
    }
  }

  /**
   * OPEN DIALOG
   * openDialogRequestMedicine()
   */
  openDialogRequestMedicine() {
    if (this.userService.getUserStatus()) {
      this.router.navigate([], { queryParams: { dialogOpen: true }, queryParamsHandling: 'merge' });
      this.dialog.open(RequestMedicineComponent, {
        maxWidth: "650px",
        width: "100%",
        height: "auto",
        panelClass: ['dialog', 'add-address']
      });
    } else {
      this.uiService.warn("Pleas Login First")
      this.router.navigate(['/', 'login']);
    }
  }


  /**
   * Dialog View
   * openDialog()
   */
  openDialog() {
    this.router.navigate([], { queryParams: { dialogOpen: true }, queryParamsHandling: 'merge' });
    if (this.userService.getUserStatus()) {
      this.dialog.open(ManageAddressComponent, {
        maxWidth: "450px",
        width: "100%",
        height: "auto",
      });
    } else {
      this.router.navigate(['/', 'login']);
    }

  }

  /**
   * BOTTOM NAV
   * onGoAccount()
   * onGoFavorite()
   */
  onGoAccount() {
    if (this.userService.getUserStatus()) {
      this._accountService.accountShow.next(true);
      this.router.navigate(['/account/my-account'], { queryParams: { profile: 'isProfile' }, queryParamsHandling: 'merge' });
    } else {
      this.router.navigate(['/login']);
    }
  }

  onGoFavorite() {
    this._accountService.accountShow.next(true);
    this.router.navigate(['/account/favorite']);
  }

  onSelectArray(dataValue: string, searchValue: HTMLInputElement) {
    searchValue.value = dataValue.toLocaleLowerCase();
    this.searchQuery = dataValue.toLocaleLowerCase();
    this.searchForm.setValue({ searchTerm: this.searchQuery })
  }


  onGoProfile() {

    setTimeout(() => {

      if (this.pendingOrders && this.pendingOrders?.length < 2) {

        const pendingData = this.pendingOrders.find(f => f.orderStatus === 1)

        if (pendingData) {
          this.router?.navigate(['/account/orders/order-list', pendingData?._id]);
        } else {
          this.router?.navigate(['/account/orders']);
        }

      }
      if (this.pendingOrders && this.pendingOrders?.length >= 2) {

        this.router?.navigate(['/account/orders']);
      }

      if (this.userService?.getUserStatus() === false) {

        this.router?.navigate(['/account/orders']);
      }
    }, 500)

  }


  // onGoProfile() {
  //
  //   if (this.allOrders && this.allOrders?.length ){
  //
  //     const pendingData =  this.allOrders.find(f=> f.orderStatus === 1)
  //
  //     if (pendingData){
  //       this.router?.navigate(['/account/orders/order-list', pendingData?._id ]);
  //     }else {
  //       this.router?.navigate(['/account/orders']);
  //     }
  //
  //   }
  //   if (this.userService?.getUserStatus() === false){
  //
  //     this.router?.navigate(['/account/orders']);
  //   }
  // }


  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.subGetData1) {
      this.subGetData1.unsubscribe();
    }
    if (this.subGetData2) {
      this.subGetData2.unsubscribe();
    }
    if (this.subGetData3) {
      this.subGetData3.unsubscribe();
    }
    if (this.subGetData4) {
      this.subGetData4.unsubscribe();
    }
    if (this.subReloadData1) {
      this.subReloadData1.unsubscribe();
    }
    if (this.subReloadData2) {
      this.subReloadData2.unsubscribe();
    }
    if (this.subReloadData3) {
      this.subReloadData3.unsubscribe();
    }
    if (this.subReloadData4) {
      this.subReloadData4.unsubscribe();
    }
    if (this.subFormData) {
      this.subFormData.unsubscribe();
    }
    if (this.subDeleteData1) {
      this.subDeleteData1.unsubscribe();
    }
    if (this.subReloadData) {
      this.subReloadData.unsubscribe();
    }

  }

}


